<div class="bmc-job-form-buttons bz-flex bz-flex--end">
  <div *ngIf="showValidationMessage" class="bmc-job-form-buttons__validation-message">
    <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-xs"></bzg-icon>
    {{ validationMessage | translate }}
  </div>
  
  <bzg-button-secondary 
    (click)="onCancelClick()">
    {{ cancelButtonText | translate }}
  </bzg-button-secondary>
  
  <bzg-button-primary 
    class="bmc-job-form-buttons__buttons--right" 
    (click)="onApplyClick()" 
    [disabled]="isApplyDisabled">
    {{ applyButtonText | translate }}
  </bzg-button-primary>
</div>
